/**
 * Titular que se muestra en «Nombre o razón social» (ADS-0169).
 *
 * El titular vive en `owner_name`. En los inmuebles migrados del legacy suele
 * faltar y `name` es el nombre de la finca, que muchas veces es la dirección:
 * se muestra solo si no lleva números, porque así suele ser un nombre de
 * persona o empresa. En una comunidad, el nombre es su razón social.
 */
const filled = (value) => value !== null && value !== undefined && String(value).trim() !== '';

export const estateHolderName = (property, propertyType = property?.type) => {
  if (filled(property?.owner_name)) return property.owner_name;
  if (!filled(property?.name)) return '-';
  if (propertyType === 'inmueble' && /\d/.test(property.name)) return '-';
  return property.name;
};
